export default "__VITE_ASSET__Bk6$wdqH__"